export default {
  setup() {
    $(document).on('ajax:success', '[data-reload-page~="true"]', function(event) {
      window.location.reload()
    });
  }
};
